var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.002,
    height: 22.001,
    viewBox: "0 0 22.002 22.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Question",
    d: "M18993.1,1776a11,11,0,1,1,11-11A11.013,11.013,0,0,1,18993.1,1776Zm-.182-8.022a1,1,0,0,0-1.053,1.049,1.061,1.061,0,0,0,.285.754,1.012,1.012,0,0,0,.768.3,1.032,1.032,0,0,0,.773-.3,1.05,1.05,0,0,0,.287-.754,1.015,1.015,0,0,0-1.061-1.049Zm.1-6.443c.49,0,.738.385.738,1.145a1.7,1.7,0,0,1-.172.73,4.083,4.083,0,0,1-.682.93,2.912,2.912,0,0,0-.672,1.078,4.836,4.836,0,0,0-.191,1.521h1.7a3.2,3.2,0,0,1,.129-.94,2.076,2.076,0,0,1,.4-.7l.568-.644a3.173,3.173,0,0,0,.867-2.06,2.452,2.452,0,0,0-2.68-2.69,2.664,2.664,0,0,0-1.975.734,2.85,2.85,0,0,0-.74,2.056h1.938a1.565,1.565,0,0,1,.229-.849A.652.652,0,0,1,18993.016,1761.535Z",
    transform: "translate(-18982.098 -1754)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.2b0eba80.svg";
export { ForwardRef as ReactComponent };